<div class="main-menu">
	<div class="command-ribbon-holder">
		<app-pos-command-ribbon></app-pos-command-ribbon>
	</div>
	<div class="canvas-ribbon-holder">
		<app-pos-canvas-ribbon [(canvasSelected)]="canvasSelected"></app-pos-canvas-ribbon>
	</div>

	<div class="pos menu-body">
		<div class="on-screen-check-holder">
			<app-pos-on-screen-check (checkSelectorChange)="checkSelectorChange.emit($event)"></app-pos-on-screen-check>
		</div>
		<div class="canvas-item-holder">
			<app-pos-canvas-items [(canvasSelected)]="canvasSelected"></app-pos-canvas-items>
		</div>
	</div>
</div>
